export {
	liteTemplate,
}

function liteTemplate(route, router, lite, noList = false) {
	router.push({
		name: route.name,
		params: {
			...route.params,
			noList: noList ? 'no-list' : '',
			lite: lite ? 'lite' : '',
		},
		query: {...route.query}
	})
}